module.exports = __webpack_public_path__ + "img/remixicon.symbol.f09b1c74.svg";